import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { PageContainer } from '../../components';
import { setAuthUser } from '../../actions';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

const LogoutComponent = ({ auth, history }) => {
  const { logout, isAuthenticated } = useAuth0();
  const dispatch = useDispatch();

  useEffect(() => {
    // Dispatch the Redux action here
    dispatch(setAuthUser(null, null, null));
  }, [dispatch]); // Include dispatch in the dependency array

  useEffect(() => {
    if (!auth.auth && isAuthenticated) {
      // Then, call the logout function
      logout({ returnTo: window.location.origin });
    } else if (!isAuthenticated) {
      history.push('/login');
    }
  }, [logout, auth, isAuthenticated, history]); // Include dispatch in the dependency array

  return (
    <div>
      <PageContainer>
        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', flex: 1, fontSize: 30, marginTop: 80 }}>
          logging out...
        </div>
      </PageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { auth } = state;
  return {
    auth,
  };
};

export default connect(mapStateToProps, {})(withRouter(LogoutComponent));
